import axios from "axios";
const select_axios = axios.create();
let include_props = "";
const props = [
  "date",
  "tile:cloud_percentage",
  "tile:data_percentage",
  "view:off_nadir",
  "view:sun_elevation",
  "platform",
];
for (let i = 0; i < props.length; i++) {
  include_props += `&include_property=${props[i]}`;
}

var select_api = {
  async get_select(select_id) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/select/request/${select_id}`;
    const response = await axios.get(request_url);
    return response;
  },

  async rerun_select(select_id, format = "geojson", additional_include = "") {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/metadata/query/${select_id}/results?format=${format}${include_props}${additional_include}`;
    const response = await axios.get(request_url);
    return response;
  },

  async get_select_info(select_id) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/metadata/query/${select_id}`;
    const response = await axios.get(request_url);
    return response;
  },

  async post_grid_query(request, format = "geojson") {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/metadata/cells/acquisitions?format=${format}${include_props}`;
    const response = await axios.post(request_url, request);
    return response;
  },

  async get_covering_cells(aoi) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/metadata/cells`;
    const response = await axios.post(request_url, aoi);
    return response;
  },

  async get_select_geojson(select_id) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/select/files/${select_id}.geojson`;
    const response = await axios.get(request_url);
    const download_url = response.data.download_link;
    const download_response = await select_axios.get(download_url);
    return download_response;
  },

  async download_selection_result(file) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/select/files/${file}`;
    const link_response = await axios.get(request_url);

    const download = await axios.get(link_response.data.download_link, {
      responseType: "blob",
      transformRequest: (data, headers) => {
        delete headers.common["Authorization"];
      },
    });

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([download.data]));
    link.download = file;
    link.click();
  },
};

export default select_api;
